import { render, staticRenderFns } from "./HpBoxes.vue?vue&type=template&id=7c645c3c&scoped=true&"
import script from "./HpBoxes.vue?vue&type=script&lang=js&"
export * from "./HpBoxes.vue?vue&type=script&lang=js&"
import style0 from "./HpBoxes.vue?vue&type=style&index=0&id=7c645c3c&lang=stylus&scoped=true&"
import style1 from "./HpBoxes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c645c3c",
  null
  
)

export default component.exports